import { setDefaults, getRenderElement } from '@udecode/slate-plugins';
import brElement from './element';

const renderBr = options => {
  const { br } = setDefaults(options, brElement);
  return getRenderElement(br);
};

export default renderBr;
